import {getTimeSinceDateObject} from "../../../utils/date-utils";
import {formatFormData} from "../../utils/submission-helpers";

export const PREVIOUS_ADDRESS_FIELDS = [
    "previous_street1",
    "previous_street2",
    "previous_city",
    "previous_state",
    "previous_zip_code",
    "previous_residential_years",
    "previous_residential_months",
];

export const REQUIRED_PREVIOUS_ADDRESS_FIELDS = PREVIOUS_ADDRESS_FIELDS.filter(
    (fieldName) => fieldName !== "previous_street2",
);

export const PREVIOUS_EMPLOYMENT_FIELDS = [
    "previous_employment_status",
    "previous_employer_name",
    "previous_employer_years",
    "previous_employer_months",
    "previous_employer_phone",
    "previous_job_title",
];

export const APPLICANT_HISTORY_FIELDS = [
    ...PREVIOUS_ADDRESS_FIELDS,
    ...PREVIOUS_EMPLOYMENT_FIELDS,
];

export const isWithinPreviousHistoryWindow = (date) => {
    if (!date?.year || !date?.month) return false;

    const elapsed = getTimeSinceDateObject(date);
    return !!elapsed && elapsed.totalMonths >= 0 && elapsed.totalMonths < 24;
};

const parseDurationPart = (value) => Number.parseInt(value, 10);

const totalMonths = (years, months) => (
    (parseDurationPart(years) * 12) + parseDurationPart(months)
);

/**
 * Formats DCA history without invoking the shared Camping World history
 * formatters. Dealertrack expects address tenure as total months, but previous
 * employment tenure as separate year and month values.
 */
export const formatDigitalCreditApplicationData = (
    fieldStates,
    {includePreviousAddress, includePreviousEmployment},
) => {
    const currentFieldStates = Object.keys(fieldStates).reduce((result, fieldName) => {
        if (!APPLICANT_HISTORY_FIELDS.includes(fieldName)) {
            result[fieldName] = fieldStates[fieldName];
        }
        return result;
    }, {});
    const data = formatFormData(currentFieldStates);

    if (includePreviousAddress) {
        data.previous_street1 = fieldStates.previous_street1.value;
        data.previous_city = fieldStates.previous_city.value;
        data.previous_state = fieldStates.previous_state.value;
        data.previous_zip_code = fieldStates.previous_zip_code.value;
        data.previous_residential_months = totalMonths(
            fieldStates.previous_residential_years.value,
            fieldStates.previous_residential_months.value,
        );
        if (fieldStates.previous_street2.value) {
            data.previous_street2 = fieldStates.previous_street2.value;
        }
    }

    if (includePreviousEmployment) {
        data.previous_employment_status = fieldStates.previous_employment_status.value;
        data.previous_employer_name = fieldStates.previous_employer_name.value;
        data.previous_employer_years = parseDurationPart(
            fieldStates.previous_employer_years.value,
        );
        data.previous_employer_months = parseDurationPart(
            fieldStates.previous_employer_months.value,
        );
        if (fieldStates.previous_employer_phone.value) {
            data.previous_employer_phone = fieldStates.previous_employer_phone.value;
        }
        if (fieldStates.previous_job_title.value) {
            data.previous_job_title = fieldStates.previous_job_title.value;
        }
    }

    return data;
};
